export enum AuthTypes {
  UPDATE_IS_AUTH = 'UPDATE_IS_AUTH',
  UPDATE_ACCESS_TOKEN = 'UPDATE_ACCESS_TOKEN',
  REGISTRATION_DATA = 'REGISTRATION_DATA',

  // LOGIN_REQUEST_LOADING = 'LOGIN_REQUEST_LOADING',
  LOGIN_REQUEST_CALL = 'LOGIN_REQUEST_CALL',
  // LOGIN_REQUEST_SUCCESS = 'LOGIN_REQUEST_SUCCESS',
  LOGIN_REQUEST_CALL_SUCCESS = 'LOGIN_REQUEST_CALL_SUCCESS',
  LOGIN_REQUEST_ERROR = 'LOGIN_REQUEST_ERROR',

  _UPDATE_SIGN_UP_FORM = 'UPDATE_SIGN_UP_FORM',
  _CLEAR_SIGN_UP_FORM = 'CLEAR_SIGN_UP_FORM',

  SIGNUP_REQUEST = 'SIGNUP_REQUEST',
  SIGNUP_REQUEST_SUCCESS = 'SIGNUP_REQUEST_SUCCESS',
  SIGNUP_REQUEST_ERROR = 'SIGNUP_REQUEST_ERROR',

  FORGOT_PASSWORD_CALL = 'FORGOT_PASSWORD_CALL',

  VERIFY_EMAIL_REQUEST = 'VERIFY_EMAIL_REQUEST',
  VERIFY_EMAIL_SUCCESS = 'VERIFY_EMAIL_SUCCESS',
  VERIFY_EMAIL_ERROR = 'VERIFY_EMAIL_ERROR',

  VERIFY_NUMBER_REQUEST = 'VERIFY_NUMBER_REQUEST',
  VERIFY_NUMBER_SUCCESS = 'VERIFY_NUMBER_SUCCESS',
  VERIFY_NUMBER_ERROR = 'VERIFY_NUMBER_ERROR',

  GET_PLANS_REQUEST = ' GET_PLANS_REQUEST',
  GET_PLANS_SUCCESS = ' GET_PLANS_SUCCESS',
  GET_PLANS_ERROR = ' GET_PLANS_ERROR',

  SEARCH_INVITEE_CALL = 'SEARCH_INVITEE_CALL',
  SEARCH_INVITEE_SUCCESS = 'SEARCH_INVITEE_SUCCESS',
}

export interface SuccessResponseType<T> {
  message: string
  status: boolean
  data: {
    data: T
  }
}

export interface RegistrationData {
  first_name: string
  last_name: string
  email: string
  phone_number: string
  password: string
  confirmPassword: string
  referred_by: string
}

export type AuthState = {
  loading?: boolean
  error?: string
  isAuthenticated: boolean
  access_token: string
  registrationData: RegistrationData
  signForm: any
  searchUser: any
}

export type Login = {
  email: string
  password: string
}

export type LoginResponse = {
  successful: boolean
  server_response: string
  user: {
    member_id: string
    first_name: string
    email: string
  }

  authorization: {
    token: string
  }
}

export type User = Pick<LoginResponse, 'user'> & {
  user: {
    member_id: string
    last_name: string
    phone_number: string
    email: string
    first_name: string
    has_withdrawal_pin: boolean
    profile_picture: string
    accounts: {
      available_balance: string | number
      total_investment: string | number
      total_interest: string | number
      total_withdrawal: string | number
    }
    kyc: {
      account_verified: boolean
      bvn_verified: boolean
      has_next_of_kin: boolean
    }
  }
}

export interface SignupAction {
  type:
    | AuthTypes.SIGNUP_REQUEST
    | AuthTypes.SIGNUP_REQUEST_SUCCESS
    | AuthTypes.SIGNUP_REQUEST_ERROR
  payload: AuthState
}

export interface verifyEmailAction {
  type:
    | AuthTypes.VERIFY_EMAIL_REQUEST
    | AuthTypes.VERIFY_EMAIL_SUCCESS
    | AuthTypes.VERIFY_EMAIL_ERROR
  payload: AuthState
}
export interface verifyNumberAction {
  type:
    | AuthTypes.VERIFY_NUMBER_REQUEST
    | AuthTypes.VERIFY_NUMBER_SUCCESS
    | AuthTypes.VERIFY_NUMBER_ERROR
  payload: AuthState
}

export type AuthAction = SignupAction | verifyEmailAction | verifyNumberAction

export const GET_USERS = 'GET_USERS'
